import { render, staticRenderFns } from "./projectOpen.vue?vue&type=template&id=faba035e&scoped=true"
import script from "./projectOpen.vue?vue&type=script&lang=js"
export * from "./projectOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faba035e",
  null
  
)

export default component.exports